import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { LiveDetailsState } from '../interface/interface';

const initialState: LiveDetailsState = {
	liveDetails: {
		categoryId: 0,
		categoryName: '',
		categorySortOrder: 0,
		corners: '',
		counter: 0,
		eventCodeId: 0,
		eventId: 0,
		eventName: '',
		eventStart: 0,
		extras: {
			liveScoreProEventId: '',
			twitchChannel: '',
			betradarLivestreamLCO: '',
		},
		gamesCount: 0,
		infos: '',
		isLive: true,
		liveMatchStatus: '',
		liveMatchStatusType: 0,
		marketTypes: [],
		parentCategoryCountryCode: '',
		parentId: 0,
		parentName: '',
		parentSortOrder: 0,
		partialScores: '',
		participants: [],
		providerId: 0,
		red: '',
		remoteStatus: 0,
		result: '',
		score: '',
		sportId: 0,
		sportName: '',
		sportSortOrder: 0,
		time: 0,
		yellow: '',
		games: [],
		finished: false,
		eventRemoteId: '',
		remoteId: 0,
		servingTeam: 0,
		disableNoFollow: false,
	},
};

const reducer = (state: LiveDetailsState = initialState, action: Action): LiveDetailsState => {
	switch (action.type) {
		case actionTypes.FETCH_EVENT_LIVE_DATA_SUCCESS:
			return {
				...state,
				liveDetails: action.payload.eventLiveData,
			};
		case actionTypes.RESET_EVENT_LIVE_DATA:
			return {
				liveDetails: initialState.liveDetails,
			};
		default:
			return state;
	}
};

export default reducer;
